import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaintenanceSiteQueryVariables = Types.Exact<{
  platform: Types.Scalars['String']['input'];
  version: Types.Scalars['String']['input'];
}>;


export type MaintenanceSiteQuery = { __typename?: 'Query', maintenanceSite?: { __typename?: 'MaintenanceSite', deprecate?: boolean | null, maintenance?: boolean | null } | null };

export const MaintenanceSiteDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"maintenanceSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenanceSite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deprecate"}},{"kind":"Field","name":{"kind":"Name","value":"maintenance"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class MaintenanceSiteGQL extends Apollo.Query<MaintenanceSiteQuery, MaintenanceSiteQueryVariables> {
    document = MaintenanceSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }